export var DateTimeFormat;
(function (DateTimeFormat) {
    DateTimeFormat[DateTimeFormat["ShortDateTime"] = 0] = "ShortDateTime";
    DateTimeFormat[DateTimeFormat["ShortDate"] = 1] = "ShortDate";
    DateTimeFormat[DateTimeFormat["LongDate"] = 2] = "LongDate";
    DateTimeFormat[DateTimeFormat["ShortTime"] = 3] = "ShortTime";
    DateTimeFormat[DateTimeFormat["LongTime"] = 4] = "LongTime";
    DateTimeFormat[DateTimeFormat["LongDateTime"] = 5] = "LongDateTime";
    DateTimeFormat[DateTimeFormat["FullDateTime"] = 6] = "FullDateTime";
    DateTimeFormat[DateTimeFormat["YearMonth"] = 7] = "YearMonth";
    DateTimeFormat[DateTimeFormat["MonthDay"] = 8] = "MonthDay";
    DateTimeFormat[DateTimeFormat["Year"] = 9] = "Year";
    DateTimeFormat[DateTimeFormat["Month"] = 10] = "Month";
    DateTimeFormat[DateTimeFormat["Day"] = 11] = "Day";
    DateTimeFormat[DateTimeFormat["Other"] = 12] = "Other";
    DateTimeFormat[DateTimeFormat["Date"] = 13] = "Date";
})(DateTimeFormat || (DateTimeFormat = {}));
;
